import { LocaleOption } from "@/dto/localeOption";
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import { Fragment } from "react";
import { CountryCodeItem } from "./countryCodeItem";
import { SelectedCountryCode } from "./selectedCountryCode";
import { CountryOption } from "../localizedTypes";

export interface CountryCodeSelectorProps {
  currentLocaleOption: LocaleOption;
  countryList: CountryOption[];
  // eslint-disable-next-line no-unused-vars
  handleLocaleChange: (country: CountryOption) => void;
}

export const CountryCodeSelector = ({
  currentLocaleOption,
  countryList,
  handleLocaleChange,
}: CountryCodeSelectorProps) => {
  if (countryList.length <= 1) {
    return (
      <SelectedCountryCode
        currentLocaleOption={currentLocaleOption}
        open={false}
        optionSize={countryList.length}
      />
    );
  }
  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <PopoverButton>
            <SelectedCountryCode
              currentLocaleOption={currentLocaleOption}
              open={open}
              optionSize={countryList.length}
            />
          </PopoverButton>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <PopoverPanel className="absolute rounded-[4px] border border-[#D1D5DB] shadow-md z-20 mt-1">
              {countryList.map((country) => {
                return (
                  <CountryCodeItem
                    close={close}
                    handleSelect={handleLocaleChange}
                    key={country.id}
                    country={country}
                  />
                );
              })}
            </PopoverPanel>
          </Transition>
        </>
      )}
    </Popover>
  );
};
